<template>
    <svg width="17" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.60023 0.447236C9.13326 1.04099 9.13326 2.00013 8.60023 2.59388L3.29727 8.50096L8.60023 14.408C9.13326 15.0018 9.13326 15.9609 8.60023 16.5547C8.0672 17.1484 7.20615 17.1484 6.67312 16.5547L0.399773 9.56667C-0.133257 8.97292 -0.133257 8.01378 0.399773 7.42003L6.67312 0.432012C7.19248 -0.146517 8.0672 -0.146516 8.60023 0.447236Z"
            :fill="color" />
    </svg>
</template>

<script>
export default {
    name: 'ChevronLeftSvg',
    props: {
        color: {
            type: String,
            default: 'currentColor',
        },
    },
}
</script>
